import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
  padding: 1vh 2vw;
`;

export const Section = styled.section`
  width: 100%;
`;

export const TitleSection = styled.p`
  color: ${theme.colors.dark};
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  width:100%;
  text-align:left;
`;
export const HeaderRightTrash = styled.button`

position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
 margin-top:2vh;
  margin-left: 40vw;
  color: ${theme.colors.dark};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;


export const FooterRightButton = styled.footer`
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  right: 0;
  margin-right: 5vw;
  color: ${theme.colors.dark};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
 
`;

export const FooterMessageDiv = styled.footer`
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  right: 0;
  margin-right: 5vw;
  color: ${theme.colors.dark};
 
`;



export const FooterLeftButton = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 5vw;
  color: ${theme.colors.dark};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;


export const FooterCenterButton  = styled.button`

position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
 
  margin-left: 50vw;
  color: ${theme.colors.dark};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

`;


export const HeaderRightButton = styled.button`

position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
 margin-top:2vh;
  margin-left: 60vw;
  color: ${theme.colors.dark};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

`;


export const HelperImpressao = styled.div`
  visibility:hidden;
  background-color: ${theme.colors.secondary};
display: block;
    width: 100%;
    max-height:0px;
    border-spacing: 0 0.5rem;
    color: red;
    overflow-x/*(eixo x)*/: auto;/*Agora quando necessário a rolagem da tabela é permitida(funcionamento para o mobile)*/
    &::-webkit-scrollbar {
    width: 0.6vw;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.dark}; /* color of the scroll thumb */
    border-radius: 0.25rem; /* roundness of the scroll thumb */
    height: 2px;
  }
    
`;